module.exports = __webpack_public_path__ + "static/img/back-10-2.3ca6f70e.png";